import { render, staticRenderFns } from "./configurations.vue?vue&type=template&id=ebfab9b2&"
import script from "./configurations.vue?vue&type=script&lang=js&"
export * from "./configurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports